/* Coming back from Zoco Chat (templates) must land on the Políticas tab of the same venue: the tabs are React state, so
   the `volver` URL carries the intent in the query (`seccion=politicas&local=<id>`). The organizer reads it once on load,
   opens that venue's form, and removes the params so a refresh or later navigation behaves normally. */

import { useEffect, useRef, useState } from "react";

const SECCION = "politicas";

/** The current URL plus the intent to reopen venue `id` on Políticas. */
export const urlVolverAPoliticas = (id, href = window.location.href) => {
  try {
    const url = new URL(href);
    url.searchParams.set("seccion", SECCION);
    if (id) url.searchParams.set("local", String(id));
    return url.toString();
  } catch {
    return href;
  }
};

/** `{ local }` (local may be "") when the URL asks for Políticas, otherwise null. Unknown values are ignored. */
export const leerVolverAPoliticas = (search = window.location.search) => {
  try {
    const params = new URLSearchParams(search);
    if (params.get("seccion") !== SECCION) return null;
    return { local: params.get("local") || "" };
  } catch {
    return null;
  }
};

/** The venue the request points at: the one with that `_id`, or the only one when the URL names none. */
export const elegirLocal = (volver, locales) => {
  if (!volver || !Array.isArray(locales)) return null;
  if (volver.local) return locales.find((l) => String(l?._id) === volver.local) || null;
  return locales.length === 1 ? locales[0] : null;
};

/** Drops the intent params from the address bar without adding a history entry. */
export const limpiarVolverAPoliticas = () => {
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("seccion") && !url.searchParams.has("local")) return;
    url.searchParams.delete("seccion");
    url.searchParams.delete("local");
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
  } catch {
    /* Address bar untouched. */
  }
};

/** Once `listo` (venues loaded), opens the venue the URL points at via `abrir(local)`, one time, and cleans the URL. */
export const useVolverAPoliticas = ({ listo, locales, abrir }) => {
  const [volver] = useState(() => leerVolverAPoliticas());
  const consumido = useRef(false);
  const abrirRef = useRef(abrir);
  abrirRef.current = abrir;

  useEffect(() => {
    if (volver) limpiarVolverAPoliticas();
  }, [volver]);

  useEffect(() => {
    if (!volver || !listo || consumido.current) return;
    consumido.current = true;
    const local = elegirLocal(volver, locales);
    if (local) abrirRef.current(local);
  }, [volver, listo, locales]);
};
